import React from "react";
import { Card } from "react-bootstrap";

interface OrderClientCardProps {
  trackingOrder: any;
}

const OrderClientCard: React.FC<OrderClientCardProps> = ({ trackingOrder }) => {
  if (!trackingOrder) return null;
  const client = trackingOrder.sale?.client;
  return (
    <Card className="mb-3">
      <Card.Body>
        <Card.Title>Tus datos</Card.Title>
        <ul>
          <li>{client?.name + " " + client?.last_name}</li>
          <li>
            {client?.address +
              ", " +
              client?.city +
              ", " +
              client?.postal_code +
              ", " +
              (client?.provinces?.name || "")}
          </li>
        </ul>
      </Card.Body>
    </Card>
  );
};

export default OrderClientCard;
